import { useEffect, useState } from "react";
import TopBar from "../UserSideComponents/NavBar/TopBar";
import BottomNavbar from "../UserSideComponents/NavBar/BottomNavbar";
import MiddleNavbar from "../UserSideComponents/NavBar/MiddleNavbar";

const UserNavbar = () => {
  const [showFullNavbar, setShowFullNavbar] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY) {
        setShowFullNavbar(false);
      } else {
        setShowFullNavbar(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="sticky top-0 w-full z-50">
      {/* Smooth animated wrapper */}
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          showFullNavbar ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <TopBar />
        <MiddleNavbar />
      </div>

      {/* Always visible */}
      <BottomNavbar />
    </div>
  );
};

export default UserNavbar;
